<template>
    <v-page-data-table
            title="菜单管理"
            key-name="id"
            :fields="fields"
            ref="producer"
            @create="onDetail"
            :height="535"
            :show-edit="false"
            :row-actions="rowActions"
            :toolbar-actions="toolActions"
            delete-api="MENU_DELETE"
            query-api="MENU_QUERY">

        <template v-slot:nodeName="{item}">
            <v-link-text :text="item.nodeName" @click="onDetail(item)"></v-link-text>
        </template>
    </v-page-data-table>
</template>

<script>
    import FndUserQueryFields from "./fields/FndMenuQuery";
    import _ from 'lodash';

    export default {
        name: "ProducerQuery",
        data() {
            return {
                fields: FndUserQueryFields,
                rowActions: [],
                toolActions: [
                    {
                        text: '新建节点',
                        color: 'primary',
                        icon: "mdi-menu",
                        action: 'create'
                    }
                ],
                currentItem: {
                    id: null,
                    name: null,
                    handler: null,
                    status: null,
                    exeCount: null,
                    type: null,
                    jobType: null,
                    jobInterval: null,
                    jobIntervalUnit: null,
                    queue: null,
                    lastExecuteTime: null,
                    lastExecuteResult: null,
                    startDate: null,
                    endDate: null,
                    jobExecuteTime: null,
                    parameter: null
                }
            }
        },
        methods: {
            onDetail(item) {
                let id = item ? item.id : undefined;
                this.$router.apmRoute("menuDetail", {id: id});
            }
        }
    }
</script>
